module.exports = __webpack_public_path__ + "static/img/rebel_pictgrid17_980x863.404ca5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/rebel_pictgrid17_980x863.jpg
// module id = Z27e
// module chunks = 0